import React, { Component } from "react";
import { PlayCircleIcon } from '@heroicons/react/20/solid'
import store from "@/redux/store";
import {showTimeRegistration, initTimeRegistration} from "@/reducers/TimeRegistration";
export function BaseTimeLogView({...props}) {
    
    const showTimeRegistrationPanelEvent = (event) => {
        store.dispatch( initTimeRegistration());
    }
    
          return (
<>
<div className="absolute top-5 right-5  col-span-1 flex rounded-md shadow-sm hidden">
    <div
      className={"flex w-38 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white bg-blue-600 pl-5 pr-5 hover:bg-blue-500"}
    >
              <button className="py-5" onClick={(event) => showTimeRegistrationPanelEvent(event)}>Direct tijd registeren</button>
    </div>
    <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
        <div className="flex-1 truncate px-4 py-2 text-sm items-center cursor-pointer">
            <PlayCircleIcon className="h-12  w-full"/>
            <p className="w-full ">Timer starten</p>
          </div>
    </div>
</div>
    </>
    )
}